module.exports = __webpack_public_path__ + "assets/images/vcr_hotel-02.0b6a5550795b38ae64b37ff22cb1b84a.svg";